import React from 'react';
import styled from 'styled-components';

import { YouTubeLogo } from '@lt/components/icons-react/messengers';

import ImageComponent from '../ImageComponent';
import {
  VIDEO_COVER_DATA_TEST_ID,
  VIDEO_COVER_PLAY_ICON_DATA_TEST_ID,
  VIDEO_COVER_IMAGE_TEST_ID,
} from './constants';
import type { IVideoCover } from './types';

export const VideoCover = (props: IVideoCover) => {
  const { coverImage, title, isSmall = false } = props;
  const { webp_x620: src, x620: fallback } = coverImage;

  return (
    <Container data-testid={VIDEO_COVER_DATA_TEST_ID}>
      <YouTubeIcon
        data-testid={VIDEO_COVER_PLAY_ICON_DATA_TEST_ID}
        $isSmall={isSmall}
      />
      <ImageComponent
        src={src ?? fallback}
        fallback={fallback}
        title={title}
        data-testid={VIDEO_COVER_IMAGE_TEST_ID}
      />
    </Container>
  );
};

const Container = styled.div`
  position: relative;

  width: 100%;
  height: 100%;
`;

const YouTubeIcon = styled(YouTubeLogo)<{ $isSmall: boolean }>`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  width: ${({ $isSmall }) => ($isSmall ? '20%' : '56px')};
`;
